import controller from './valid.controller';

export default {
  bindings: {
    packet: '<',
    msisdn: '=',
    valid: '='
  },
  controller,
  template: require('./valid.html')
};


// WEBPACK FOOTER //
// src/app/no-auth/buy/valid/valid.component.ts